import { Container, Title, Text, Button, Stack, Box } from '@mantine/core';
import { IconRocket } from '@tabler/icons-react';
import { motion } from 'framer-motion';
import { HOME_CONTENT } from '../../data/homeContent';

/**
 * PreFooter component provides a final call-to-action at the bottom of the page.
 * @param {Object} props - Component properties.
 * @param {Function} props.onOpen - Function to open the bot management tool.
 */
export default function PreFooter({ onOpen }) {
    const { preFooter } = HOME_CONTENT;
    return (
        <Box
            py={{ base: 100, md: 160 }}
            style={{
                position: 'relative',
                overflow: 'hidden',
                backgroundColor: '#050505',
                borderTop: '1px solid rgba(255,255,255,0.05)'
            }}
        >
            <div style={{
                position: 'absolute',
                top: 0, left: 0, right: 0, bottom: 0,
                backgroundImage: `
                  linear-gradient(rgba(255, 255, 255, 0.02) 1px, transparent 1px),
                  linear-gradient(90deg, rgba(255, 255, 255, 0.02) 1px, transparent 1px)
                `,
                backgroundSize: '40px 40px',
                zIndex: 0,
                maskImage: 'radial-gradient(circle at center, black 40%, transparent 100%)'
            }} />

            <div style={{
                position: 'absolute',
                top: '50%', left: '50%',
                transform: 'translate(-50%, -50%)',
                width: '600px', height: '600px',
                background: 'radial-gradient(circle, rgba(34, 139, 230, 0.1) 0%, transparent 70%)',
                zIndex: 0,
                pointerEvents: 'none'
            }} />

            <Container size="md" style={{ position: 'relative', zIndex: 1 }}>
                <Stack align="center" gap="xl">
                    <motion.div
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.8 }}
                    >
                        <Title
                            order={2}
                            ta="center"
                            size={50} // Massive text
                            fw={900}
                            style={{ letterSpacing: '-2px', lineHeight: 1.1, textShadow: '0 0 40px rgba(34, 139, 230, 0.3)' }}
                        >
                            {preFooter.title} <span style={{ color: '#fff' }}>{preFooter.titleHighlight}</span> {preFooter.titleSuffix}
                        </Title>
                        <Text c="dimmed" ta="center" mt="md" size="xl" maw={600} mx="auto">
                            {preFooter.subtitle}
                        </Text>
                    </motion.div>

                    <motion.div
                        whileHover={{ scale: 1.05 }}
                        whileTap={{ scale: 0.95 }}
                    >
                        <Button
                            size="xl"
                            radius="xl"
                            h={60} // Taller button
                            px={50} // Wider button
                            variant="gradient"
                            gradient={{ from: 'blue', to: 'cyan' }}
                            leftSection={<IconRocket size={28} />}
                            onClick={onOpen}
                            style={{
                                fontSize: '1.2rem',
                                boxShadow: '0 0 50px rgba(34, 139, 230, 0.4)', // Stronger glow
                            }}
                        >
                            {preFooter.cta}
                        </Button>
                    </motion.div>

                    <Text size="sm" c="dimmed" style={{ opacity: 0.5 }}>
                        {preFooter.footerText}
                    </Text>
                </Stack>
            </Container>
        </Box>
    );
}